const SalesProjection = {
  "cannot edit because a manufacture was included by copilot": "Cannot edit because a manufacture was included by copilot"
};

export default SalesProjection;